import React, { useState, useEffect, Fragment, useRef } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box, Card, Grid, TextField, makeStyles, Container, Button, CardContent, Divider, InputLabel, CardHeader, Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableFooter,
  MenuItem
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { trackPromise } from 'react-promise-tracker';
import { Formik, validateYupSchema } from 'formik';
import * as Yup from "yup";
import authService from '../../../../utils/permissionAuth';
import tokenService from '../../../../utils/tokenDecoder';
import { useNavigate } from 'react-router-dom';
import { useAlert } from "react-alert";
import xlsx from 'json-as-xlsx';
import ReactToPrint from "react-to-print";
import CreatePDF from './CreatePDF';
import { LoadingComponent } from './../../../../utils/newLoader';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';


const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  colorCancel: {
    backgroundColor: "red",
  },
  colorRecord: {
    backgroundColor: "green",
  },
  tableContainer: {
    marginTop: theme.spacing(2),
  },
  table: {
    border: '1px solid #ccc',
  },
  tableHead: {
    backgroundColor: theme.palette.background.default,
    borderBottom: '1px solid #ccc',
    borderTop: '1px solid #ccc',
  },
  tableCell: {
    borderBottom: 'none',
  },
  tableHeaderCell: {
    fontWeight: 'bold',
  },
  tableCellRight: {
    textAlign: 'right',
    paddingRight: '40px',
    borderBottom: 'none',
  },
  tableCellLeft: {
    textAlign: 'left',
    borderBottom: 'none',
  },
  tableHeaderCellRight: {
    textAlign: 'right',
    fontWeight: 'bold',
  },
  tableHeaderCellLeft: {
    textAlign: 'left',
    fontWeight: 'bold',
  },
  tableHeaderCellBorderLeft: {
    textAlign: 'left',
    fontWeight: 'bold',
    borderLeft: '1px solid #ccc',
  },
  tableHeaderCellBorderRight: {
    textAlign: 'right',
    fontWeight: 'bold',
  },
}));

const screenCode = 'ALLDEBTLIST';

export default function AllDebtList(props) {
  const [title, setTitle] = useState("All Debt List");
  const classes = useStyles();
  const [GroupList, setGroupList] = useState([]);
  const [FactoryList, setFactoryList] = useState([]);
  const [routeList, setRouteList] = useState();
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [debtRequestDetail, setDebtRequestDetail] = useState({
    groupID: 0,
    factoryID: 0,
    routeID: 0,
    month: "",   
    year: "",
    monthName: ""
  });
  const [allDebtList, setAllDebtList] = useState([]);
  const [toDate, setToDate] = useState([]);
  const [selectedSearchValues, setSelectedSearchValues] = useState({
    groupName: "0",
    factoryName: "0",
    routeName:"0",
    monthName: ""
  });
  const navigate = useNavigate();
  const alert = useAlert();
  const componentRef = useRef();
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
  });
  const [csvHeaders, SetCsvHeaders] = useState([])
  const getPageMargins = () => {
    return `@media print {
            @page {
            size: A4 Landscape !important;
            background-color: white !important;
        }
        body {
            transform-origin: top left;
            background-color: white !important;
        }
    }`;
  };
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  
  useEffect(() => {
    trackPromise(getPermission());
    trackPromise(getGroupsForDropdown());
    
    
    const currentDate = new Date();
    let monthNames = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
    const month = currentDate.getMonth() + 1;
    const year = currentDate.getFullYear();
    
    setSelectedDate(currentDate);
    setDebtRequestDetail(prevState => ({
      ...prevState,
      month: month.toString(),
      year: year.toString(),
      monthName: monthNames[month - 1]
    }));
  }, []);

  useEffect(() => {
    trackPromise(
      getFactoriesForDropdown());
  }, [debtRequestDetail.groupID]);

  useEffect(() => {
    trackPromise(
      getRoutesByFactoryID());
  }, [debtRequestDetail.factoryID]);

   useEffect(() => {
      if (debtRequestDetail.factoryID > 0 && debtRequestDetail.groupID > 0) {
        trackPromise(GetBalancePaymentYearMonthForDropDown());
      }
    }, [debtRequestDetail.factoryID, debtRequestDetail.groupID]);

  async function getPermission() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWALLDEBTLIST');

    if (isAuthorized === undefined) {
      navigate('/404');
    }
    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
    });

    setDebtRequestDetail(prevState => ({
      ...prevState,
      groupID: parseInt(tokenService.getGroupIDFromToken()),
      factoryID: parseInt(tokenService.getFactoryIDFromToken())
    }));
  }
    async function GetBalancePaymentYearMonthForDropDown() {
      var response = await services.GetBalancePaymentYearMonth(debtRequestDetail.groupID, debtRequestDetail.factoryID);
  
      const applicableYear = parseInt(response.applicableYear);
      const applicableMonth = parseInt(response.applicableMonth) - 1;
  
      const selectedDate = new Date(applicableYear, applicableMonth);
  
      setSelectedDate(selectedDate);
      setDebtRequestDetail(prevState => ({
        ...prevState,
        month: applicableMonth.toString(),
        year: applicableYear.toString(),
        monthName: ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"][applicableMonth - 1]
      }));
      
    };
  

  async function getGroupsForDropdown() {
    const groups = await services.getAllGroups();
    setGroupList(groups);
  }

  async function getFactoriesForDropdown() {
    const factories = await services.getFactoryByGroupID(debtRequestDetail.groupID);
    setFactoryList(factories);
  }

  async function getRoutesByFactoryID() {
    const routes = await services.getRoutesForDropDown(debtRequestDetail.factoryID);
    setRouteList(routes);
  }

  async function GetAllDebtList() {
    const applicableYear = selectedDate.getFullYear().toString();
    const applicableMonth = (selectedDate.getMonth() + 1).toString();
    const response = await services.GetAllDebtListForReport(
      debtRequestDetail.groupID, 
      debtRequestDetail.factoryID, 
      debtRequestDetail.routeID,
      applicableMonth,
      applicableYear
    );

    getSelectedDropdownValuesForReport(debtRequestDetail.groupID, debtRequestDetail.factoryID, debtRequestDetail.routeID);

    if (response.statusCode == "Success" && response.data != null) {
      setAllDebtList(response.data);
      createDataForExcel(response.data);

      if (response.data.length == 0) {
        alert.error("No records to display");
      }
    }
    else {
      alert.error("Error");
    }
    
    var date = selectedDate.toLocaleString('en-us',{month:'short', year:'numeric'});
    setToDate(date);
  }

  async function createDataForExcel(array) {
    var res = [];

    if (array != null) {
      array.map(x => {
        var vr = {
          'Route Name': x.routeName,
          'Registration Number': x.registrationNumber,
          'Customer Name': x.name,
          'Last Month Crop(Kg)': x.lastMonthCrop,
          'This Month Crop(Kg)': x.thisMonthCrop,
          'Debt Amount (Rs)': x.amount,
          'Last Supply Month': x.lastSupplyMonth,
          'Loan Balance (Rs)': x.loanBalance,
        }
        res.push(vr);
      });
    }
    let routeName = "All Routes";
  if (debtRequestDetail.routeID && debtRequestDetail.routeID !== "0" && routeList) {
    routeName = routeList[debtRequestDetail.routeID] || "All Routes";
  }
  res.push('');
    var vr = {
      'Route Name':`Group : ${selectedSearchValues.groupName}` ,
      'Registration Number': `Factory :${selectedSearchValues.factoryName}`,
    }
    res.push(vr);
    
    var vr = {
      'Route Name':`Route: ${routeName}` ,
      'Registration Number': `Month & Year: ${selectedSearchValues.monthName || debtRequestDetail.monthName} / ${debtRequestDetail.year}`,
    }
    res.push(vr);

    return res;
  }

  async function createFile() {
    var file = await createDataForExcel(allDebtList);
    var settings = {
      sheetName: 'All Debt List',
      fileName: 'All Debt List - ' + selectedSearchValues.groupName + ' - ' + selectedSearchValues.factoryName + ' - ' + toDate,
      writeOptions: {}
    }

    let keys = Object.keys(file[0])
    let tempcsvHeaders = csvHeaders;
    keys.map((sitem, i) => {
      tempcsvHeaders.push({ label: sitem, value: sitem })
    })

    let dataA = [
      {
        sheet: 'All Debt List',
        columns: tempcsvHeaders,
        content: file
      }
    ]

    xlsx(dataA, settings);
  }

  function generateDropDownMenu(data) {
    let items = []
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
      }
    }
    return items;
  }

  function handleChange(e) {
    const target = e.target;
    const value = target.value
    setDebtRequestDetail({
      ...debtRequestDetail,
      [e.target.name]: value
    });
    setAllDebtList([]);
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
      </Grid>
    )
  }

  function getSelectedDropdownValuesForReport(groupID, factoryID, routeID) {
    setSelectedSearchValues({
      ...selectedSearchValues,
      groupName: GroupList[groupID],
      factoryName: FactoryList[factoryID],
      routeName: routeList ? routeList[routeID] : "All Routes",
      monthName: debtRequestDetail.monthName
    });
  }
  
  function handleDateChange(date) {
    if (!date) return; 
    
    let monthNames = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
    var month = date.getUTCMonth() + 1; 
    var year = date.getUTCFullYear();
    let monthName = monthNames[month - 1];
    
    setDebtRequestDetail({
      ...debtRequestDetail,
      month: month.toString(),
      year: year.toString(),
      monthName: monthName
    });
  
    setSelectedDate(date);
    setAllDebtList([]); 
  }
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  
  return (
    <Fragment>
      <LoadingComponent />
      <Page className={classes.root} title={title}>
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: debtRequestDetail.groupID,
              factoryID: debtRequestDetail.factoryID,
              month: debtRequestDetail.month,
              year: debtRequestDetail.year
            }}
            validationSchema={
              Yup.object().shape({
                groupID: Yup.number().required('Group is required').min(1, 'Group is required'),
                factoryID: Yup.number().required('Factory is required').min(1, 'Factory is required'),
                month: Yup.string().required('Month is required'),
                year: Yup.string().required('Year is required')
              })
            }
            onSubmit={() => trackPromise(GetAllDebtList())}
            enableReinitialize
          >
            {({
              errors,
              handleBlur,
              handleSubmit,
              touched,
              setFieldValue
            }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader title={cardTitle(title)} />
                    <PerfectScrollbar>
                      <Divider />
                      <CardContent>
                        <Grid container spacing={3}>
                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="groupID">
                              Group *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.groupID && errors.groupID)}
                              fullWidth
                              helperText={touched.groupID && errors.groupID}
                              size='small'
                              name="groupID"
                              onBlur={handleBlur}
                              onChange={(e) => {
                                handleChange(e);
                                setFieldValue('groupID', e.target.value);
                              }}
                              value={debtRequestDetail.groupID}
                              variant="outlined"
                              id="groupID"
                              disabled={!permissionList.isGroupFilterEnabled}
                            >
                              <MenuItem value="0">--Select Group--</MenuItem>
                              {generateDropDownMenu(GroupList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="factoryID">
                              Factory *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.factoryID && errors.factoryID)}
                              fullWidth
                              helperText={touched.factoryID && errors.factoryID}
                              size='small'
                              name="factoryID"
                              onBlur={handleBlur}
                              onChange={(e) => {
                                handleChange(e);
                                setFieldValue('factoryID', e.target.value);
                              }}
                              value={debtRequestDetail.factoryID}
                              variant="outlined"
                              id="factoryID"
                              disabled={!permissionList.isFactoryFilterEnabled}
                            >
                              <MenuItem value="0">--Select Factory--</MenuItem>
                              {generateDropDownMenu(FactoryList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="routeID">
                              Route
                            </InputLabel>
                            <TextField select
                              fullWidth
                              size='small'
                              name="routeID"
                              onChange={(e) => handleChange(e)}
                              value={debtRequestDetail.routeID}
                              variant="outlined"
                              id="routeID"
                            >
                              <MenuItem value="0">--Select Route--</MenuItem>
                              {generateDropDownMenu(routeList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={8}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <DatePicker
                                autoOk
                                variant="inline"
                                openTo="month"
                                views={["year", "month"]}
                                label="Year and Month "
                                helperText={touched.month && errors.month ? errors.month : "Select applicable month"}
                                value={selectedDate}
                                size='small'
                                onChange={(date) => {
                                  handleDateChange(date);
                                  if (date) {
                                    const month = date.getUTCMonth() + 1;
                                    const year = date.getUTCFullYear();
                                    setFieldValue('month', month.toString());
                                    setFieldValue('year', year.toString());
                                  }
                                }}
                                required
                                error={Boolean(touched.month && errors.month)}
                              />
                            </MuiPickersUtilsProvider>
                          </Grid>
                        </Grid>
                        <Box display="flex" flexDirection="row-reverse" p={2} >
                          <Button
                            color="primary"
                            type="submit"
                            variant="contained"
                          >
                            Search
                          </Button>
                        </Box>
                      </CardContent>
                      <Box minWidth={1050}>
  {allDebtList.length > 0 && (
    <TableContainer component={Paper} className={classes.tableContainer}>
      <Table className={classes.table} size="small" stickyHeader>
        <TableHead className={classes.tableHead}>
          <TableRow>
            <TableCell className={classes.tableHeaderCellBorderLeft} style={{width:'12%'}}>Route Name</TableCell>
            <TableCell className={classes.tableHeaderCellLeft}>Registration Number</TableCell>
            <TableCell className={classes.tableHeaderCellLeft}style={{width:'18%'}}>Customer Name</TableCell>
            <TableCell className={classes.tableHeaderCellRight}>Last Month Crop (KG)</TableCell>
            <TableCell className={classes.tableHeaderCellRight}>This Month Crop (KG)</TableCell>
            <TableCell className={classes.tableHeaderCellRight}>Debt Amount (RS.)</TableCell>
            <TableCell className={classes.tableHeaderCellBorderRight}>Loan Balance (Rs.)</TableCell>
            <TableCell className={classes.tableHeaderCellRight}>Last Supply Month</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {allDebtList
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((row, index) => (
              <TableRow key={index}>
                <TableCell className={classes.tableCellLeft}style={{width:'12%'}}>{row.routeName}</TableCell>
                <TableCell className={classes.tableCellLeft}>{row.registrationNumber}</TableCell>
                <TableCell className={classes.tableCellLeft}style={{width:'18%'}}>{row.name}</TableCell>
                <TableCell className={classes.tableCellRight}>
                  {Number(row.lastMonthCrop).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </TableCell>
                <TableCell className={classes.tableCellRight}>
                  {Number(row.thisMonthCrop).toLocaleString()}
                </TableCell>
                <TableCell className={classes.tableCellRight}>
                  {Number(row.amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </TableCell>
                <TableCell className={classes.tableCellRight}>
                  {Number(row.loanBalance).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </TableCell>
                <TableCell className={classes.tableCellRight}>{row.lastSupplyMonth}</TableCell>
              </TableRow>
            ))}
        </TableBody>
        <TableFooter style={{ position: "sticky", bottom: 0 }}>
          <TableRow style={{ borderTop: '1px solid #ccc' }}>
            <TableCell colSpan={3} className={classes.tableCellLeft} style={{ fontWeight: "bolder", fontSize:'14px', color:"black", borderTop:'1px solid #ccc' }}>
              Total
            </TableCell>
            <TableCell className={classes.tableCellRight} style={{ fontWeight: "bolder", fontSize:'14px', color:"black", borderTop:'1px solid #ccc' }}>
              {allDebtList.reduce((sum, row) => sum + Number(row.lastMonthCrop), 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </TableCell>
            <TableCell className={classes.tableCellRight} style={{ fontWeight: "bolder", fontSize:'14px', color:"black", borderTop:'1px solid #ccc' }}>
              {allDebtList.reduce((sum, row) => sum + Number(row.thisMonthCrop), 0).toLocaleString()}
            </TableCell>
            <TableCell className={classes.tableCellRight} style={{ fontWeight: "bolder", fontSize:'14px', color:"black", borderTop:'1px solid #ccc' }}>
              {allDebtList.reduce((sum, row) => sum + Number(row.amount), 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </TableCell>
            <TableCell className={classes.tableCellRight} style={{ fontWeight: "bolder", fontSize:'14px', color:"black", borderTop:'1px solid #ccc' }}>
              {allDebtList.reduce((sum, row) => sum + Number(row.loanBalance), 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </TableCell>
            <TableCell className={classes.tableCellRight} style={{ fontWeight: "bolder", fontSize:'14px', color:"black", borderTop:'1px solid #ccc' }}>
              
            </TableCell>
          </TableRow>
        </TableFooter>
      </Table>
      <TablePagination
        rowsPerPageOptions={[10, 20, 30]}
        component="div"
        count={allDebtList.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </TableContainer>
  )}
</Box>
                      {allDebtList.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                          <Button
                            color="primary"
                            id="btnRecord"
                            type="button"
                            variant="contained"
                            style={{ marginRight: '1rem' }}
                            className={classes.colorRecord}
                            onClick={() => createFile()}
                          >
                            EXCEL
                          </Button>
                          <ReactToPrint
                            documentTitle={"All Debt List"}
                            trigger={() => <Button
                              color="primary"
                              id="btnRecord"
                              type="button"
                              variant="contained"
                              style={{ marginRight: '1rem' }}
                              className={classes.colorCancel}
                            >
                              PDF
                            </Button>}
                            content={() => componentRef.current}
                            pageStyle={getPageMargins()}
                          />
                          <div hidden={true}>
                            <CreatePDF ref={componentRef}
                              allDebtList={allDebtList} searchData={selectedSearchValues}
                              toDate={toDate}
                            />
                          </div>
                        </Box> : null}
                    </PerfectScrollbar>
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Page>
    </Fragment>
  );
}